import {
  Stack
} from "./chunk-WKZT7ZXJ.mjs";

// src/stack/v-stack.tsx
import { forwardRef } from "@chakra-ui/system";
import { jsx } from "react/jsx-runtime";
var VStack = forwardRef((props, ref) => /* @__PURE__ */ jsx(Stack, { align: "center", ...props, direction: "column", ref }));
VStack.displayName = "VStack";

export {
  VStack
};
